/** Minutes in a day: the unit a daily or nightly resource is booked and priced in. */
export const MINUTES_PER_DAY = 24 * 60;
